module.exports = __webpack_public_path__ + "img/ryjq_logo.fd9fc239.png";